import type { TutorialStepId } from '../../../application/store/tutorialSteps';
import type { OverlayStepId } from '../../../application/store/TutorialStore';

export type TutorialCatalogStep = {
  id: TutorialStepId;
  title: string;
  subtitle: string;
  path: string;
  /** When set, dashboard tutorial force-opens this page overlay before navigating. */
  overlay?: OverlayStepId;
};

/** Single source of truth for dashboard tutorial card steps. */
export const TUTORIAL_CATALOG: TutorialCatalogStep[] = [
  {
    id: 'marketplace-connection',
    title: 'Connect to your store',
    subtitle: 'Be able to see all available data',
    path: '/dashboard/onboarding',
  },
  {
    id: 'products',
    title: 'Set up your product catalog',
    subtitle: 'Add data to your catalog',
    path: '/product-catalog/products',
    overlay: 'products',
  },
  {
    id: 'inventory',
    title: 'Add your warehouses',
    subtitle: 'Keep your stock levels up to date',
    path: '/inventory',
    overlay: 'inventory',
  },
  {
    id: 'suppliers',
    title: 'Add your suppliers',
    subtitle: 'Be able to see all available data',
    path: '/suppliers',
    overlay: 'suppliers',
  },
  {
    id: 'purchase-order',
    title: 'Create your first order',
    subtitle: 'Be able to see all available data',
    path: '/purchasing',
    overlay: 'purchase-order',
  },
];

/** @deprecated Prefer TUTORIAL_CATALOG */
export const DASHBOARD_TUTORIAL_STEPS = TUTORIAL_CATALOG;

export type DashboardTutorialStepId = (typeof TUTORIAL_CATALOG)[number]['id'];
